import React from 'react';
import { useCountdownMs } from './useCountdownMs'; // tu hook
import { Button } from '@mui/material';

export default function CountdownButton({
   startTime,
   durationMs,
   textoActivo = 'Intentar nuevamente',
   textoContando = 'Espere...',
   onClick = () => {},
   className
}) {
   const { hours, minutes, seconds, timeLeftMs } = useCountdownMs(startTime, durationMs);

   const format = (n) => n.toString().padStart(2, '0');
   const tiempoTexto =
      (hours > 0 ? `${format(hours)}:` : '') + `${format(minutes)}:${format(seconds)}`;

   const estaActivo = timeLeftMs <= 0;

   return (
      <Button
         disabled={!estaActivo}
         onClick={onClick}
         className={className}
      >
         {estaActivo ? textoActivo : `${textoContando} (${tiempoTexto})`}
      </Button>
   );
}
